import {useMemo} from 'react';

import {
  ProcedureStepConfigEditorContext,
  ProcedureStepConfigEditorContextValue,
} from 'procedures/design/step-config/ProcedureStepConfigEditorContext';

export interface StructuredTableContexts {
  procedureStepConfigEditorContext: ProcedureStepConfigEditorContextValue | undefined;
}

/**
 * Get contexts relevant to a StructuredTable to pass through adapter functions and callbacks.
 *
 * StructuredTables rely on a few different context values depending on where they are used. Since we don't
 * have general stores to save this information, this object is a value that can be easily passed to functions
 * to provide that additional context.
 *
 * DO NOT ADD CONTEXTS WITH FREQUENT CHANGES OR PERFORMANCE WILL BE BAD
 */
export default function useStructuredTableContexts(): StructuredTableContexts {
  const procedureStepConfigEditorContext = ProcedureStepConfigEditorContext.useContext();
  return useMemo(
    (): StructuredTableContexts => ({
      procedureStepConfigEditorContext,
    }),
    [procedureStepConfigEditorContext]
  );
}
